var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-empty"},[_c('div',{staticClass:"figure"}),_vm._v(" "),_c('div',{staticClass:"msg"},[_vm._v("还没有创建版本")]),_vm._v(" "),_c('div',{staticClass:"msg-lite"},[_vm._v("版本记录帮您回溯项目创作历史，轻松还原到某一关键节点。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc9abcb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/historyEmpty.vue
// module id = null
// module chunks = 